(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19501],{

/***/ 28793:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scholarship/UNSAT",
      function () {
        return __webpack_require__(2483);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h1", {
    target: "e15q8xmq0",
    label: "H1"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.BOLD */ .F3.Pl, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H1 */ .F3.H1, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.tablet */ .AV.tablet, "){font-size:24px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.mobile */ .AV.mobile, "){font-size:28px;line-height:120%;}", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H1);
H1.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H1.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 63322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_Radio__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24691);
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30553);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


/* eslint-disable react/jsx-props-no-spreading */ 




var StyledRadio = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Radio__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "embu7f30",
    label: "StyledRadio"
})("padding:0px;padding-right:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_4B */ .t8.BM, ";:hover{background-color:var(--color-base-1);}color:var(--color-text-primary);");
var Label = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "embu7f31",
    label: "Label"
})("margin-left:0px;");
var RadioButton = function(props) {
    var label = props.label, className = props.className;
    var radioButton = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledRadio, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disableFocusRipple: true,
        disableTouchRipple: true,
        disableRipple: true,
        size: "small",
        color: "default"
    }, props));
    if (label) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Label, {
        control: radioButton,
        label: label,
        className: className
    });
    return radioButton;
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);
RadioButton.propTypes = {
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    label: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
        prop_types__WEBPACK_IMPORTED_MODULE_6___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_6___default().any))
    ])
};
RadioButton.defaultProps = {
    checked: false,
    onChange: null,
    label: ""
};


/***/ }),

/***/ 2483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ UNSAT; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/Container/BookScholarshipSchool/BookScholarshipSchoolCover.jsx + 1 modules
var BookScholarshipSchoolCover = __webpack_require__(85155);
// EXTERNAL MODULE: ./src/components/Container/BookScholarshipSchool/Toppers.jsx
var Toppers = __webpack_require__(30981);
// EXTERNAL MODULE: ./src/components/Container/BookScholarshipSchool/FAQSection.jsx
var FAQSection = __webpack_require__(56381);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/components/Base/CircularLoader/CircularLoader.jsx
var CircularLoader = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/components/Container/BookScholarshipSchool/AboutUnacademy.jsx
var AboutUnacademy = __webpack_require__(39880);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/components/Container/BookScholarship/styles.jsx
var styles = __webpack_require__(47189);
// EXTERNAL MODULE: ./src/components/Container/BookScholarshipSchool/styles.jsx
var BookScholarshipSchool_styles = __webpack_require__(66496);
;// CONCATENATED MODULE: ./src/components/Container/BookScholarship/constants.js


var LEAD_GENERATION_FORM_VIEWED = "Lead Generation Form - Viewed";
var LEAD_GENERATION_FORM_CONTINUE = "Lead Generation Form - Continue";
var LEAD_GENERATION_FORM_SUBMIT = "Lead Generation Form - Submit";
var dateContent = [
    {
        month: "AUG",
        date: "Aug 1",
        text: "Registration starts"
    },
    {
        month: "OCT",
        date: "Oct 8 and 15",
        text: "Exam dates"
    },
    {
        month: "OCT",
        date: "Oct 21",
        text: "Result announcement"
    }
];
var examAndClasses = [
    {
        id: "1",
        label: "Foundation Class 9",
        value: "Foundation Class 9"
    },
    {
        id: "2",
        label: "Foundation Class 10",
        value: "Foundation Class 10"
    },
    {
        id: "3",
        label: "IIT JEE Class 11",
        value: "IIT JEE Class 11"
    },
    {
        id: "4",
        label: "IIT JEE Class 12",
        value: "IIT JEE Class 12"
    },
    {
        id: "5",
        label: "IIT JEE Dropper",
        value: "IIT JEE Dropper"
    },
    {
        id: "6",
        label: "NEET UG Class 11",
        value: "NEET UG Class 11"
    },
    {
        id: "7",
        label: "NEET UG Class 12",
        value: "NEET UG Class 12"
    },
    {
        id: "8",
        label: "NEET UG Dropper",
        value: "NEET UG Dropper"
    },
    {
        id: "9",
        label: "Others Class 11",
        value: "Others Class 11"
    },
    {
        id: "10",
        label: "Others Class 12",
        value: "Others Class 12"
    }
];
var radioOptions = [
    {
        id: 1,
        label: "At an offline centre",
        value: "offline"
    },
    {
        id: 2,
        label: "Online test",
        value: "online"
    }
];
var getCities = function(cityCenterMapping) {
    var distinctCities = [];
    cityCenterMapping.forEach(function(cityObj) {
        var city = cityObj.city;
        if (distinctCities.indexOf(city) === -1) {
            distinctCities.push(city);
        }
    });
    var citiesOptions = distinctCities.map(function(disCity, index) {
        return {
            id: index,
            label: disCity,
            value: disCity
        };
    });
    return citiesOptions;
};
var getCentres = function(cityCenterMapping, selectedCity) {
    var centres = [];
    cityCenterMapping.forEach(function(cityObj) {
        if (cityObj.city === (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.value)) {
            centres.push(cityObj.center);
        }
    });
    var centreOptions = centres.map(function(disCen, index) {
        return {
            id: index,
            label: disCen,
            value: disCen
        };
    });
    return centreOptions;
};
var getCityOption = function(city, cityCenterMapping) {
    var cities = getCities(cityCenterMapping);
    return cities.find(function(cityObj) {
        return cityObj.value === city;
    });
};
var getCenterOption = function(center, cityCenterMapping, city) {
    var centres = getCentres(cityCenterMapping, city);
    return centres.find(function(cityObj) {
        return cityObj.value === center;
    });
};
var modifiedFormData = function(formData, dateSlots, cityCenterMapping) {
    var dateAndTimeOption = dateSlots.find(function(dateObj) {
        return dateObj.value === formData.dateAndTime;
    });
    var examAndClassesOption = examAndClasses.find(function(exam) {
        return exam.value === formData.examAndClass;
    });
    var testTypeOption = radioOptions.find(function(radio) {
        return radio.value === formData.testType;
    });
    var city = getCityOption(formData.city, cityCenterMapping);
    var centreOption = getCenterOption(formData.centerName, cityCenterMapping, city);
    var updatedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
        dateAndTime: dateAndTimeOption,
        examAndClass: examAndClassesOption,
        testType: testTypeOption,
        centerName: centreOption,
        city: city
    });
    return updatedData;
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./src/components/Base/Form/useForm.js
var useForm = __webpack_require__(11391);
// EXTERNAL MODULE: ./src/stores/toggleables.js
var toggleables = __webpack_require__(85690);
// EXTERNAL MODULE: ./src/constants/toggleables.js
var constants_toggleables = __webpack_require__(28119);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/api-helper/fetch.js
var fetch = __webpack_require__(5618);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var actions_auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/components/Container/OfflineCentres/constants.js
var constants = __webpack_require__(89916);
// EXTERNAL MODULE: ./src/stores/snackbar.js
var snackbar = __webpack_require__(97296);
// EXTERNAL MODULE: ./src/components/Container/OfflineCentres/PostPaymentLearnerDetails/styles.jsx
var PostPaymentLearnerDetails_styles = __webpack_require__(22348);
// EXTERNAL MODULE: ./src/components/Base/Divider/Divider.jsx
var Divider = __webpack_require__(46736);
// EXTERNAL MODULE: ./src/components/Base/H3/H3.jsx
var H3 = __webpack_require__(82034);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/components/Container/OfflineCentres/PostPaymentLearnerDetails/apiHelper.js
var apiHelper = __webpack_require__(49499);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(7397);
// EXTERNAL MODULE: ./src/components/Container/Login/CountryMenu.jsx
var CountryMenu = __webpack_require__(37328);
// EXTERNAL MODULE: ./src/components/Base/Form/Field.jsx + 1 modules
var Field = __webpack_require__(45814);
// EXTERNAL MODULE: ./src/components/Container/BookScholarship/utils.js
var utils = __webpack_require__(70736);
;// CONCATENATED MODULE: ./src/components/Container/BookScholarship/PersonalDetails.jsx









var renderErrorMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* Error */.jj, {
        children: message
    });
};
var PersonalDetails = function(param) {
    var registrar = param.registrar, country = param.country;
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var formData = registrar.data;
    var fullName = formData.fullName, email = formData.email, phoneNum = formData.phoneNum;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostPaymentLearnerDetails_styles/* FormContainer */.Yb, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FormSectionHeading */.qn, {
                children: "Personal details"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                    registrar: registrar,
                    name: "fullName",
                    rules: [
                        (0,utils/* isRequired */.q9)("Name is required")
                    ],
                    render: function(param) {
                        var onChange = param.onChange, value = param.value, hasError = param.hasError;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledTextField */.tH, {
                            placeholder: "Enter full name",
                            value: value,
                            onChange: function(data) {
                                return onChange(data.target.value);
                            },
                            error: hasError,
                            disabled: isLoggedIn && fullName
                        });
                    },
                    renderError: renderErrorMessage
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                    registrar: registrar,
                    name: "phoneNum",
                    rules: [
                        (0,utils/* isRequired */.q9)("Mobile number is required"),
                        (0,utils/* isLengthMatchError */.Nh)("Please enter a valid mobile number", 10)
                    ],
                    render: function(param) {
                        var onChange = param.onChange, value = param.value, hasError = param.hasError;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledNumberField */.jt, {
                            fullWidth: true,
                            startAdornment: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputAdornment/* default */.Z, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountryMenu/* default */.Z, {
                                    country: country,
                                    disabled: true
                                })
                            }),
                            placeholder: "Enter your mobile number",
                            onChange: function(_, data) {
                                return onChange(data);
                            },
                            value: value,
                            inputProps: {
                                type: "tel",
                                maxLength: 10,
                                required: true
                            },
                            type: "tel",
                            error: hasError,
                            disabled: isLoggedIn && phoneNum
                        });
                    },
                    renderError: renderErrorMessage
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                    registrar: registrar,
                    name: "email",
                    rules: [
                        (0,utils/* isRequired */.q9)("Email is required"),
                        (0,utils/* isValidEmail */.vV)("Please enter a valid email address")
                    ],
                    render: function(param) {
                        var onChange = param.onChange, value = param.value, hasError = param.hasError;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledTextField */.tH, {
                            placeholder: "Enter email address",
                            value: value,
                            onChange: function(data) {
                                return onChange(data.target.value);
                            },
                            inputProps: {
                                type: "email",
                                required: true
                            },
                            type: "email",
                            error: hasError,
                            disabled: isLoggedIn && email
                        });
                    },
                    renderError: renderErrorMessage
                })
            })
        ]
    });
};
PersonalDetails.propTypes = {
    registrar: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    country: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var BookScholarship_PersonalDetails = (PersonalDetails);

// EXTERNAL MODULE: ./src/components/Base/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(63322);
;// CONCATENATED MODULE: ./src/components/Container/BookScholarship/TestDetails.jsx











var TestDetails_renderErrorMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* Error */.jj, {
        children: message
    });
};
var TestDetails = function(param) {
    var registrar = param.registrar, cityCenterMapping = param.cityCenterMapping, dateSlots = param.dateSlots, setIsOnlineSelected = param.setIsOnlineSelected, isOnlineSelected = param.isOnlineSelected;
    var ref = (0,react.useState)([]), citiesOptions = ref[0], setCitiesOptions = ref[1];
    var ref1 = (0,react.useState)([]), centreOptions = ref1[0], setCentreOptions = ref1[1];
    var ref2 = (0,react.useState)(false), isOfflineDisabled = ref2[0], setIsOfflineDisabled = ref2[1];
    (0,react.useEffect)(function() {
        setCitiesOptions(getCities(cityCenterMapping));
    }, [
        cityCenterMapping
    ]);
    var setData = registrar.setData, registrarData = registrar.data;
    (0,react.useEffect)(function() {
        var ref;
        var centres = getCentres(cityCenterMapping, registrar === null || registrar === void 0 ? void 0 : (ref = registrar.data) === null || ref === void 0 ? void 0 : ref.city);
        setCentreOptions(centres);
    }, [
        registrar.data.city,
        cityCenterMapping,
        setData
    ]);
    var updateCenter = function(updatedCity) {
        var centres = getCentres(cityCenterMapping, updatedCity);
        setCentreOptions(centres);
        setData("centerName", centres[0]);
    };
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var updateOfflineRadio = function() {
        var testTypeData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var disabledOfflineForSlot = testTypeData.disabledOfflineForSlot;
        if (disabledOfflineForSlot) {
            setIsOnlineSelected(true);
            setData("centerName", "");
            setData("city", "");
            setData("testType", radioOptions[1]);
            setIsOfflineDisabled(true);
            return;
        }
        setIsOfflineDisabled(false);
    };
    var checkIsOfflineDisable = function(dateAndTime) {
        var selectedSlot = dateSlots.find(function(slot) {
            return (slot === null || slot === void 0 ? void 0 : slot.id) === (dateAndTime === null || dateAndTime === void 0 ? void 0 : dateAndTime.id);
        });
        if (selectedSlot) updateOfflineRadio(selectedSlot);
    };
    (0,react.useEffect)(function() {
        var dateAndTime = registrarData.dateAndTime;
        if (dateAndTime) checkIsOfflineDisable(dateAndTime);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registrarData === null || registrarData === void 0 ? void 0 : registrarData.dateAndTime
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarshipSchool_styles/* FormContainer */.Yb, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FormSectionHeading */.qn, {
                    children: "Test details"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                        registrar: registrar,
                        name: "examAndClass",
                        rules: [
                            (0,utils/* isRequired */.q9)("Exam & class is required")
                        ],
                        render: function(param) {
                            var onChange = param.onChange, value = param.value;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledDropdown */.EI, {
                                options: examAndClasses,
                                placeholder: "Select your exam & class",
                                selectedOption: value,
                                onOptionClick: function(data) {
                                    return onChange(data);
                                },
                                buttonWidth: "100%"
                            });
                        },
                        renderError: TestDetails_renderErrorMessage
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* StyledTextP1 */.lX, {
                            children: "How do you want to take the test?"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                            registrar: registrar,
                            name: "testType",
                            render: function(param) {
                                var onChange = param.onChange;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* RadioCardWrapper */.fP, {
                                    children: radioOptions.map(function(type) {
                                        var ref;
                                        var data = registrar.data;
                                        var isDisabled = type.id === radioOptions[0].id && isOfflineDisabled;
                                        var isChecked = isDisabled ? false : ((ref = data.testType) === null || ref === void 0 ? void 0 : ref.id) === type.id;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* RadioWrapper */.Sc, {
                                            $checked: isChecked,
                                            $isDisabled: isDisabled,
                                            onClick: function() {
                                                if (!isDisabled) {
                                                    onChange(type);
                                                    setIsOnlineSelected(type.id === radioOptions[1].id);
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RadioButton/* default */.Z, {
                                                checked: isChecked,
                                                disabled: isDisabled,
                                                label: type.label
                                            })
                                        }, type.id);
                                    })
                                });
                            },
                            renderError: TestDetails_renderErrorMessage
                        })
                    ]
                }),
                !isOnlineSelected ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                                registrar: registrar,
                                name: "city",
                                rules: [
                                    (0,utils/* isRequired */.q9)("City is required")
                                ],
                                render: function(param) {
                                    var onChange = param.onChange, value = param.value;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledDropdown */.EI, {
                                        options: citiesOptions,
                                        placeholder: "Select city for test",
                                        selectedOption: value,
                                        onOptionClick: function(data) {
                                            onChange(data);
                                            updateCenter(data);
                                        },
                                        buttonWidth: "100%"
                                    });
                                },
                                renderError: TestDetails_renderErrorMessage
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                                registrar: registrar,
                                name: "centerName",
                                rules: [
                                    (0,utils/* isRequired */.q9)("Centre is required")
                                ],
                                render: function(param) {
                                    var onChange = param.onChange, value = param.value;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledDropdown */.EI, {
                                        options: centreOptions,
                                        placeholder: "Select a centre",
                                        selectedOption: value,
                                        onOptionClick: function(data) {
                                            return onChange(data);
                                        },
                                        buttonWidth: "100%",
                                        menuWidth: centreOptions.length > 0 ? "auto" : "233px",
                                        stripLength: isMobile ? 40 : null
                                    });
                                },
                                renderError: TestDetails_renderErrorMessage
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PostPaymentLearnerDetails_styles/* FieldWrapper */.n2, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* StyledTextP1 */.lX, {
                            children: "Preferred date & time for test"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field/* default */.Z, {
                            registrar: registrar,
                            name: "dateAndTime",
                            rules: [
                                (0,utils/* isRequired */.q9)("Date & time is required")
                            ],
                            render: function(param) {
                                var onChange = param.onChange, value = param.value;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledDropdown */.EI, {
                                    options: dateSlots,
                                    placeholder: "Select date & time",
                                    selectedOption: value,
                                    onOptionClick: function(data) {
                                        updateOfflineRadio(data);
                                        onChange(data);
                                    },
                                    buttonWidth: "100%",
                                    menuWidth: "auto"
                                });
                            },
                            renderError: TestDetails_renderErrorMessage
                        })
                    ]
                })
            ]
        })
    });
};
TestDetails.propTypes = {
    registrar: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var BookScholarship_TestDetails = (TestDetails);

;// CONCATENATED MODULE: ./src/components/Container/BookScholarship/BookScholarshipForm.jsx




/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/forbid-prop-types */ 























var errorMessage = "Something went wrong, Try again later";
var BookScholarshipForm = function(param) {
    var heroForm = param.heroForm, dateSlots = param.dateSlots, cityCenterMapping = param.cityCenterMapping, formDetails = param.formDetails, setIsRedirection = param.setIsRedirection, isRedirecting = param.isRedirecting, isOnlineSelected = param.isOnlineSelected, setIsOnlineSelected = param.setIsOnlineSelected;
    var redirectionUrl = heroForm.redirectionUrl, fields = heroForm.fields, title = heroForm.header.title, formPrice = heroForm.formPrice;
    var getState = (0,es/* useStore */.oR)().getState;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var ref = (0,toggleables/* useToggleable */.F7)(constants_toggleables/* LOGIN_DRAWER */.es), openLoginDrawer = ref.openElement;
    var query = (0,next_router.useRouter)().query;
    (0,react.useEffect)(function() {
        setIsOnlineSelected(formDetails.testType.value === "online");
    }, [
        formDetails
    ]);
    var ref1 = (0,react.useState)(null), payload = ref1[0], setPayload = ref1[1];
    var ref2 = (0,snackbar/* useSnackbar */.Ds)(), showSnackbar = ref2.open;
    var ref3 = (0,useForm/* default */.Z)({
        data: formDetails
    }), registrar = ref3.registrar, onFormSubmit = ref3.onFormSubmit;
    var ref4 = (0,react.useState)(false), isSubmitting = ref4[0], setIsSubmiiting = ref4[1];
    (0,react.useEffect)(function() {
        analytics/* segment.track */.EX.track(segment/* UNSAT_Page_Landed */.Cnu, {
            form_type: "non_school"
        });
    }, []);
    var updateFormSubmitted = debounce_default()(function() {
        setIsSubmiiting(false);
    }, 1000);
    var setUnsatData = (0,react.useCallback)(function() {
        var body = {
            "form-type": 3,
            "form-details": (0,_object_spread/* default */.Z)({}, payload)
        };
        setIsSubmiiting(true);
        (0,fetch/* default */.Z)((0,apiHelper/* getSubmitFormURL */.zx)(), {
            getState: getState,
            requestType: "POST",
            body: body
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                var errorResponse, referral_code;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(res.error || res.error_code)) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 3;
                            return res.error.response.json();
                        case 3:
                            errorResponse = _ctx.sent;
                            showSnackbar({
                                message: (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.message) || "Something went wrong. Please try again.",
                                type: "error"
                            });
                            _ctx.next = 8;
                            break;
                        case 7:
                            {
                                setIsRedirection(true);
                                analytics/* segment.track */.EX.track(segment/* UNSAT_Registration_Submitted */.bem, {
                                    unsat_exam_class: payload === null || payload === void 0 ? void 0 : payload.examAndClass,
                                    test_mode: payload.testType,
                                    city_name: payload.city,
                                    centre: payload.centerName,
                                    exam_slot: payload.dateAndTime,
                                    form_type: "non_school",
                                    goal_uid: constants/* OFFLINE_GOAL_UID */.WU
                                });
                                referral_code = query.referral_code;
                                if (referral_code) router.push({
                                    pathname: redirectionUrl,
                                    query: {
                                        referral_code: referral_code
                                    }
                                });
                                else router.push(redirectionUrl);
                            }
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function() {
            showSnackbar({
                type: "SET_SNACKBAR_MESSAGE",
                message: errorMessage,
                messageType: "error"
            });
        }).finally(updateFormSubmitted());
    }, [
        showSnackbar,
        getState,
        payload,
        redirectionUrl,
        router,
        setIsRedirection
    ]);
    (0,react.useEffect)(function() {
        if (isLoggedIn && payload && !isRedirecting) {
            setUnsatData();
        }
    }, [
        isLoggedIn,
        payload,
        isRedirecting
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var ref, ref1, ref2, ref3, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setPayload({
                            fullName: data.fullName,
                            email: data.email,
                            phoneNum: data.phoneNum,
                            examAndClass: (ref = data.examAndClass) === null || ref === void 0 ? void 0 : ref.value,
                            testType: (ref1 = data.testType) === null || ref1 === void 0 ? void 0 : ref1.value,
                            city: (ref2 = data.city) === null || ref2 === void 0 ? void 0 : ref2.value,
                            centerName: (ref3 = data.centerName) === null || ref3 === void 0 ? void 0 : ref3.value,
                            dateAndTime: (ref4 = data.dateAndTime) === null || ref4 === void 0 ? void 0 : ref4.value,
                            isFormSubmitted: true
                        });
                        if (!isLoggedIn) {
                            dispatch((0,actions_auth/* sendOtpOrEmail */.AO)(String(data.phoneNum), constants/* DEFAULT_COUNTRY.code */.UF.code, 1)).then(function() {
                                var response = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                var ref;
                                if (!(response === null || response === void 0 ? void 0 : (ref = response.result) === null || ref === void 0 ? void 0 : ref.is_registered)) {
                                    dispatch((0,actions_auth/* setLocalEmailAndName */.PW)(String(data.email), String(data.fullName)));
                                }
                            });
                            dispatch((0,actions_auth/* setLocalPhoneNumber */.Rd)(String(data.phoneNum), constants/* DEFAULT_COUNTRY */.UF));
                            openLoginDrawer();
                        }
                        analytics/* segment.track */.EX.track(segment/* UNSAT_Registration_PI_Details */.ANC, {
                            unsat_exam_class: data === null || data === void 0 ? void 0 : data.examAndClass.value,
                            test_mode: data.testType.value,
                            city_name: data.city.value,
                            centre: data.centerName.value,
                            exam_slot: data.dateAndTime.value,
                            form_type: "non_school",
                            phone_number: data.phoneNum,
                            email_id: data.email
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnSubmit = onFormSubmit(onSubmit);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* PostPaymentFormContainer */.Be, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarshipSchool_styles/* StyledPaper */.Mt, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* BookAClassForm */.eX, {
                    $display: true,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ClassTitle */.oy, {
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* FormContainer */.Yb, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarship_PersonalDetails, {
                                    registrar: registrar,
                                    country: constants/* DEFAULT_COUNTRY */.UF
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarship_TestDetails, {
                                    registrar: registrar,
                                    fields: fields,
                                    dateSlots: dateSlots,
                                    cityCenterMapping: cityCenterMapping,
                                    isOnlineSelected: isOnlineSelected,
                                    setIsOnlineSelected: setIsOnlineSelected
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* SubmitWrapper */.qw, {
                            children: [
                                formPrice ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* PriceWrapper */.vN, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* PriceP2 */.JD, {
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H3/* default */.Z, {
                                            children: formPrice
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* BookClassButon */.Y4, {
                                    onClick: handleOnSubmit,
                                    width: "auto",
                                    variant: isSubmitting ? "disabled" : "filled",
                                    label: "Continue to payment",
                                    color: "black"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* AcceptTerms */.Rg, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* TermsContent */.S2, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* StyP2 */.lJ, {
                                        children: "By continuing, you agree to"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* TermsLink */.Ag, {
                                        target: "_blank",
                                        href: "/unsat-terms",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostPaymentLearnerDetails_styles/* StyledTermsSpan */.qE, {
                                            children: " Unacademy\u2019s terms"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
BookScholarshipForm.propTypes = {
    heroForm: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var BookScholarship_BookScholarshipForm = (BookScholarshipForm);

// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/components/Base/H1/H1.jsx
var H1 = __webpack_require__(8918);
// EXTERNAL MODULE: ./src/components/Base/H5/H5.jsx
var H5 = __webpack_require__(43807);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
;// CONCATENATED MODULE: ./src/components/Container/BookScholarship/ResultsAnnoucement.jsx









var ResultsAnnounementWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo66nd60",
    label: "ResultsAnnounementWrapper"
})("width:100vw;height:80vh;background:rgba(45,129,247,0.06);display:flex;justify-content:center;align-items:center;flex-direction:column;margin-bottom:-", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
var StyledH1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H1/* default */.Z, {
    target: "eo66nd61",
    label: "StyledH1"
})("width:480px;font-size:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";margin:", styleConstants/* Spacings.SPACING_8B */.t8.B3, " 0 ", styleConstants/* Spacings.SPACING_8B */.t8.B3, " 0;text-align:center;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{width:100%;}");
var ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eo66nd62",
    label: "ButtonWrapper"
})("display:flex;align-items:center;justify-content:center;");
var StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "eo66nd63",
    label: "StyledButton"
})("width:252px;height:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";margin-top:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var StyledH5 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H5/* default */.Z, {
    target: "eo66nd64",
    label: "StyledH5"
})("margin-left:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var UNSAT_IMAGE_URL = "https://static.uacdn.net/web-cms/unsat_school_form.png?q=75&w=640&fm=webp";
var ResultsAnnoucement = function() {
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var handleGoToHomepage = function() {
        (0,pushRoute/* default */.Z)("/", "/");
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ResultsAnnounementWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                src: UNSAT_IMAGE_URL,
                width: isMobile ? styleConstants/* Spacings.SPACING_38B */.t8.JI : styleConstants/* Spacings.SPACING_50B */.t8.gO,
                height: isMobile ? styleConstants/* Spacings.SPACING_14B */.t8.zJ : styleConstants/* Spacings.SPACING_18B */.t8.UX,
                alt: "illustration"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledH1, {
                children: "Thank you for showing your interest in UNSAT"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                        src: "unsat-results-icon.svg",
                        width: styleConstants/* Spacings.SPACING_5B */.t8.zj,
                        height: styleConstants/* Spacings.SPACING_5B */.t8.zj,
                        alt: "illustration"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledH5, {
                        children: "Results will be declared in November"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                label: "Go to home page",
                onClick: handleGoToHomepage,
                color: "black"
            })
        ]
    });
};
/* harmony default export */ var BookScholarship_ResultsAnnoucement = (ResultsAnnoucement);

;// CONCATENATED MODULE: ./src/components/Container/BookScholarship/BookScholarship.jsx



/* eslint-disable no-unreachable */ /* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/forbid-prop-types */ 















var defaultFormState = {
    fullName: "",
    phoneNum: "",
    email: "",
    examAndClass: "",
    testType: radioOptions[0],
    city: "",
    centerName: "",
    dateAndTime: ""
};
var defaultSyllabusURL = "https://static.uacdn.net/web-cms/UNSAT_Syllabus_Pattern_Non_Schools.pdf";
var BookScholarship = function(param) {
    var apiResponse = param.apiResponse, dateSlots = param.dateSlots, nonSchoolFAQHTML = param.nonSchoolFAQHTML, cityCenterMapping = param.cityCenterMapping, formDetails = param.formDetails;
    var description = (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.description) ? JSON.parse(apiResponse.description) : null;
    var heroForm = description.heroForm, features = description.features, heroContent = description.heroContent, prodigyInfo = description.prodigyInfo;
    var formData = (formDetails || {}).formData;
    var ref = (0,react.useState)(defaultFormState), formState = ref[0], setFormState = ref[1];
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var userFullName = (0,useMyInfo/* default */.Z)(auth/* getFullName */.Pp);
    var userPhoneNum = (0,useMyInfo/* default */.Z)(auth/* getMePhone */.T7);
    var userEmail = (0,useMyInfo/* default */.Z)(auth/* getEmailId */.ie);
    var ref1 = (0,react.useState)(false), isRedirecting = ref1[0], setIsRedirection = ref1[1];
    var ref2 = (0,react.useState)(false), isOnlineSelected = ref2[0], setIsOnlineSelected = ref2[1];
    (0,react.useEffect)(function() {
        if (formData === null || formData === void 0 ? void 0 : formData.isFormSubmitted) {
            setFormState(modifiedFormData(formData, dateSlots, cityCenterMapping));
        }
    }, []);
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            setFormState(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    fullName: userFullName,
                    phoneNum: userPhoneNum,
                    email: userEmail
                });
            });
        }
    }, [
        userFullName,
        userPhoneNum,
        userEmail
    ]);
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarship_ResultsAnnoucement, {});
    if (!description) return;
    if (isRedirecting) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* ProgressWrapper */.RH, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularLoader/* default */.Z, {})
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BookScholarshipSchool_styles/* BottomContainer */.he, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BookScholarshipSchool_styles/* OuterContainer */.$h, {
                $isOnlineForm: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles/* Container */.W2, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarshipSchoolCover/* default */.Z, {
                                heroContent: heroContent,
                                dateContent: dateContent,
                                syllabusURL: defaultSyllabusURL,
                                isOnlineForm: true
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarship_BookScholarshipForm, {
                                heroForm: heroForm,
                                dateSlots: dateSlots,
                                cityCenterMapping: cityCenterMapping,
                                formDetails: formState,
                                isRedirecting: isRedirecting,
                                setIsRedirection: setIsRedirection,
                                isOnlineSelected: isOnlineSelected,
                                setIsOnlineSelected: setIsOnlineSelected
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarshipSchool_styles/* SachinWrapper */.QU, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                            src: "offline-centres/sachin-mweb.png",
                            layout: "fill",
                            alt: "sachin"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AboutUnacademy/* default */.Z, {
                features: features,
                isOnlineSelected: isOnlineSelected,
                isOnlineForm: true
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toppers/* default */.Z, {
                prodigyInfo: prodigyInfo
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FAQSection/* default */.Z, {
                contentFAQs: nonSchoolFAQHTML
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles/* StyledDivider */.IW, {})
        ]
    });
};
BookScholarship.propTypes = {
    apiResponse: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var BookScholarship_BookScholarship = (BookScholarship);

// EXTERNAL MODULE: ./src/components/Container/BookScholarship/apiHelper.js
var BookScholarship_apiHelper = __webpack_require__(40921);
// EXTERNAL MODULE: ./src/layout/HeaderTemplates/Base.jsx
var Base = __webpack_require__(84279);
// EXTERNAL MODULE: ./src/utils/setupInitialProps.js
var setupInitialProps = __webpack_require__(57714);
// EXTERNAL MODULE: ./src/layout/FreeLayout/FreeLayout.jsx
var FreeLayout = __webpack_require__(11559);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
;// CONCATENATED MODULE: ./src/pages/scholarship/UNSAT.jsx












var unsat = function(param) {
    var unsatData = param.unsatData, dateSlots = param.dateSlots, nonSchoolFAQHTML = param.nonSchoolFAQHTML, cityCenterMapping = param.cityCenterMapping, formDetails = param.formDetails;
    if (!unsatData) return;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: "UNSAT - Scholarship Test to Ace IIT JEE, NEET UG and Class 9 to 12 Exams",
                description: "Looking to crack IIT JEE or NEET? Attempt UNSAT scholarship test and get up to 100% scholarship at Unacademy offline centres and on online subscription."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookScholarship_BookScholarship, {
                formDetails: formDetails,
                apiResponse: JSON.parse(unsatData),
                dateSlots: dateSlots,
                nonSchoolFAQHTML: nonSchoolFAQHTML,
                cityCenterMapping: cityCenterMapping
            })
        ]
    });
};
unsat.pageInfo = {
    layoutOptions: {
        disableDarkMode: true,
        hideHeader: true
    },
    isMWebSupported: true
};
unsat.getInitialProps = (0,setupInitialProps/* default */.Z)(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var cookiesFromServer, ref, accessToken, refreshToken, formDetails, promises, response, unsatData, dateSlots, nonSchoolFAQHTML, cityCenterMapping;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cookiesFromServer = param.cookies;
                    ref = cookiesFromServer || {}, accessToken = ref.accessToken, refreshToken = ref.refreshToken;
                    ;
                    if (!(accessToken && refreshToken)) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return (0,apiHelper/* getFormData */.zi)(3, accessToken);
                case 7:
                    formDetails = _ctx.sent;
                    _ctx.next = 13;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](4);
                    formDetails = {};
                case 13:
                    promises = [];
                    promises.push((0,BookScholarship_apiHelper/* fetchUnsatData */.E9)());
                    promises.push((0,BookScholarship_apiHelper/* fetchNonSchoolSlots */.uy)());
                    promises.push((0,BookScholarship_apiHelper/* fetchFAQs */.vO)());
                    promises.push((0,BookScholarship_apiHelper/* fetchCityCenterMapping */.b$)());
                    _ctx.next = 20;
                    return Promise.all(promises);
                case 20:
                    response = _ctx.sent;
                    unsatData = response[0];
                    dateSlots = response[1];
                    nonSchoolFAQHTML = response[2];
                    cityCenterMapping = response[3];
                    return _ctx.abrupt("return", {
                        unsatData: JSON.stringify(unsatData),
                        dateSlots: dateSlots,
                        nonSchoolFAQHTML: nonSchoolFAQHTML,
                        cityCenterMapping: cityCenterMapping,
                        formDetails: formDetails
                    });
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                10
            ]
        ]);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}(), unsat.pageInfo);
unsat.Layout = FreeLayout/* default */.Z;
unsat.Layout.displayName = "UNSAT";
unsat.propTypes = {
    unsatData: (prop_types_default()).string.isRequired
};
unsat.Layout.propTypes = {
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node
    ]).isRequired
};
/* harmony default export */ var UNSAT = (unsat);
unsat.Wrapper = PageReduxProviderWrapper["default"];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,64097,21322,74061,347,29238,16766,35659,9720,46571,16050,94336,4392,72047,32410,10900,45172,49774,92888,40179], function() { return __webpack_exec__(28793); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);